import React, {Fragment} from 'react';
import {Listbox, Transition} from "@headlessui/react";
import {ChevronUpDownIcon} from "@heroicons/react/24/solid";
import {classNames} from "../../../utils/common";

const AccountLogoPicker = ({logo, setLogo, logos, smallerSize = false}) => {
    return (
        <Listbox as="div" value={logo} onChange={setLogo} className={classNames(smallerSize ? "mt-2 mx-3" : "mt-5 mx-10")}>
            {({open}) => (
                <>
                    <Listbox.Label className={classNames(
                        smallerSize ? "ml-1 text-xs" : "ml-3 text-sm",
                        "block font-medium text-gray-700"
                    )}>Logo</Listbox.Label>
                    <div className={classNames(smallerSize ? "mt-0.5 h-7" : "mt-1 h-10", "relative")}>
                        <Listbox.Button
                            className={classNames(
                                smallerSize
                                    ? "h-7 pl-1.5 pr-1.5 text-xs"
                                    : "h-10 pl-3 pr-3 text-sm",
                                "relative bg-white border border-gray-300 rounded-md shadow-sm text-left cursor-default focus:outline-none focus:ring-1 focus:ring-indigo-500 focus:border-indigo-500"
                            )}
                        >
                                <span className="flex justify-between">
                                    <span className="flex items-center block">
                                        <div className={classNames(smallerSize ? "h-5 w-5" : "h-8 w-8", "flex-shrink-0")}>
                                            <img className={classNames(smallerSize ? "h-5 w-5" : "h-8 w-8", "rounded-full")} src={`${process.env.PUBLIC_URL}/images/acc_logos/` + logo} alt=""/>
                                        </div>
                                    </span>
                                <span className={classNames(smallerSize ? "ml-1" : "ml-3", "block flex items-center pointer-events-none")}>
                                    <ChevronUpDownIcon className={classNames(smallerSize ? "h-4 w-4" : "h-5 w-5", "text-gray-400")} aria-hidden="true"/>
                                </span>
                            </span>
                        </Listbox.Button>

                        <Transition
                            show={open}
                            as={Fragment}
                            leave="transition ease-in duration-100"
                            leaveFrom="opacity-100"
                            leaveTo="opacity-0"
                        >
                            <Listbox.Options
                                className={classNames(
                                    smallerSize ? "w-52 p-1.5 gap-0.5" : "w-64 p-2 gap-1",
                                    "absolute z-50 mt-1 bg-white shadow-lg max-h-96 rounded-md grid grid-cols-5 ring-1 ring-black ring-opacity-5 overflow-auto focus:outline-none"
                                )}
                            >
                                {logos.map((logoOption) => (
                                    <Listbox.Option
                                        key={logoOption}
                                        className={({active, selected}) =>
                                            classNames(
                                                active ? 'bg-indigo-100' : '',
                                                selected ? 'ring-2 ring-indigo-500' : '',
                                                smallerSize ? 'p-1' : 'p-1.5',
                                                'relative cursor-default select-none rounded-md flex items-center justify-center'
                                            )
                                        }
                                        value={logoOption}
                                    >
                                        <div className={classNames(smallerSize ? "h-5 w-5" : "h-8 w-8", "flex-shrink-0")}>
                                            <img className={classNames(smallerSize ? "h-5 w-5" : "h-8 w-8", "rounded-full")} src={`${process.env.PUBLIC_URL}/images/acc_logos/` + logoOption} alt=""/>
                                        </div>
                                    </Listbox.Option>
                                ))}
                            </Listbox.Options>
                        </Transition>
                    </div>
                </>)}
        </Listbox>
    );
};

export default AccountLogoPicker;
